import ContentLoader from 'react-content-loader';

import { useSkeletonColors } from 'hooks';

export default function AppointmentLoader() {
  const skeletonColors = useSkeletonColors();

  return (
    <ContentLoader
      speed={2}
      width="100%"
      height="800px"
      {...skeletonColors}
    >
      <rect x="0" y="0" rx="3" ry="3" width="50%" height="25px" />
      <rect x="0" y="60px" rx="3" ry="3" width="20%" height="15px" />
      <rect x="50%" y="60px" rx="3" ry="3" width="20%" height="15px" />

      <rect x="0" y="90px" rx="3" ry="3" width="45%" height="200px" />
      <rect x="50%" y="90px" rx="3" ry="3" width="45%" height="200px" />

      <rect x="0" y="330px" rx="3" ry="3" width="20%" height="15px" />
      <rect x="0" y="360px" rx="3" ry="3" width="95%" height="90px" />

      <rect x="0" y="480px" rx="3" ry="3" width="20%" height="15px" />
      <rect x="0" y="510px" rx="3" ry="3" width="95%" height="90px" />

    </ContentLoader>
  );
}
